import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H18.75C19.1642 12 19.5 12.3358 19.5 12.75C19.5 13.1642 19.1642 13.5 18.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgDash;
